import { render, staticRenderFns } from "./last_saved.vue?vue&type=template&id=b5726d7e&scoped=true&"
import script from "./last_saved.vue?vue&type=script&lang=ts&"
export * from "./last_saved.vue?vue&type=script&lang=ts&"
import style0 from "./last_saved.vue?vue&type=style&index=0&id=b5726d7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5726d7e",
  null
  
)

export default component.exports